"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ModalCloseButton = ({
  color = '#c2c2c2',
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledModalCloseButton, {
  type: "button",
  "aria-label": "Close",
  ...otherProps,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: color,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M2.525.707a1 1 0 00-1.414 0l-.404.404a1 1 0 000 1.414l15.034 15.034a1 1 0 001.414 0l.404-.404a1 1 0 000-1.414L2.525.707z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M15.741.707a1 1 0 011.414 0l.404.404a1 1 0 010 1.414L2.525 17.559a1 1 0 01-1.414 0l-.404-.404a1 1 0 010-1.414L15.741.707z"
      })]
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "aria-hidden": "true",
    children: "\xD7"
  })]
});

var _default = ModalCloseButton;
exports.default = _default;